import React from 'react';
import exact from 'prop-types-exact';

import { BaseField } from '../../../fields';

const validatePassword = (fieldValues) => {
  let errors = '';

  if (!fieldValues) {
    errors = 'Required';
  } else if (fieldValues.length < 6) {
    errors = 'Password too short.';
  }
  return errors;
};

export const validate = (values) => {
  const errors = {};

  errors.password = validatePassword(values.password);

  if (!errors.password && (values.password !== values.password_confirmation)) {
    errors.password = 'Passwords do not match.';
    errors.password_confirmation = 'Password do not match.';
  }

  return errors;
};


const PasswordResetRequestFormSection = (props) => {
  return (
    <div>
      <BaseField name="password" label="Password" componentProps={{ type: 'password' }} />
      <BaseField name="password_confirmation" label="Confirm Password" componentProps={{ type: 'password' }} />
    </div>
  );
};


PasswordResetRequestFormSection.propTypes = exact({});

export default PasswordResetRequestFormSection;
